<template>
    <div style="width: 100%">
        <v-row dense>
            <v-col cols="1" />
            <v-col cols="10">
                <div class="header">
                    Choix de l'offre
                </div>
            </v-col>
            <v-col cols="1">
                <v-btn-icon icon="$oss-zoom-in" @Click="isDialogOpen = true"></v-btn-icon>
            </v-col>
        </v-row>
        <BusinessOffer :isWithoutLogingView="true" :isDisplayPrice="true" v-model:offer="_offer"> </BusinessOffer>
        <v-form>
            <v-radio-group v-model="_offer" required color="primary">
                <v-row>
                    <v-col cols="4" />
                    <v-col cols="2">
                        <v-radio class="d-flex justify-center align-center" :value="4" />
                    </v-col>
                    <v-col cols="2">
                        <v-radio class="d-flex justify-center align-center" :value="8" />
                    </v-col>
                    <v-col cols="2">
                        <v-radio class="d-flex justify-center align-center" :value="5" />
                    </v-col>
                    <v-col cols="2">
                        <v-radio class="d-flex justify-center align-center" :value="6" />
                    </v-col>
                </v-row>
            </v-radio-group>
        </v-form>
        <oss-dialog
            :hide-valid="true"
            :hide-next="true"
            title="offre"
            height="100vh"
            width="70vw"
            v-model="isDialogOpen"
        >
            <BusinessOffer :isWithoutLogingView="true" :isDisplayPrice="true" v-model:offer="_offer" style="overflow-y: hidden; overflow-x: hidden;" max-height="59vh"> </BusinessOffer>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Offer_type } from "@/types/offer.types";
import BusinessOffer from "@/views/offer/BusinessOffer.vue";
import { Component, Vue, toNative, Model } from "vue-facing-decorator";

@Component({
    components: {
        BusinessOffer,
    },
})
export class OfferForm extends Vue {
    @Model({ default: Offer_type.BUSINESS_BASIC, name: "offer" }) _offer: Offer_type;

    isDialogOpen: boolean = false;
}

export default toNative(OfferForm);
</script>

<style scoped>
.header {
    text-align: center;
    margin-bottom: 2vh;
    font-weight: bold;
}
</style>
